var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 26,
    viewBox: "0 0 34 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 178",
    d: "M3.386 13.545h32",
    transform: "translate(-2.386 -.544)",
    style: {
      fill: "none",
      stroke: "#002d72",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 179",
    d: "M3.386 6.772h32",
    style: {
      fill: "none",
      stroke: "#002d72",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    transform: "translate(-2.386 -5.772)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 180",
    d: "M3.386 20.317h32",
    transform: "translate(-2.386 4.683)",
    style: {
      fill: "none",
      stroke: "#002d72",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLogo);
export default __webpack_public_path__ + "static/media/menu_logo.1d2edb4f6619e808ba1a50039c721b90.svg";
export { ForwardRef as ReactComponent };